import qs from 'query-string';
import { get, post, put, patch, del } from './baseApi';

export const ServiceApi = {
    fetch: (query) => get(`/services?${qs.stringify(query)}`),
    fetchById: (id) => get(`/services/${id}`),
    create: (data) => post('/services', data),
    update: (id, data) => put(`/services/${id}`, data),
    patch: (id, data, options) => patch(`/services/${id}`, data, options),
    delete: (id) => del(`/services/${id}`),
    fetchBovines: (id, query, options) => get(`/services/${id}/bovines?${qs.stringify(query)}`, options),
    updateBovine: (id, data, options) => put(`/services/bovines/${id}`, data, options),
    deleteBovine: (id, options) => del(`/services/bovines/${id}`, options),
    export: (id, format, query) => get(`/services/${id}/export/${format}?${qs.stringify(query)}`, { responseType: 'blob' }),
};
